import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client/core"
import { ApolloProvider } from "@apollo/client/react"
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs"
import React, { ReactNode, useEffect } from "react"

import { DEFAULT_LOCALE, normalizeLocale } from "@/constants/locales"
import i18n from "@/i18n"

import { GetCurrentUserDocument, GetCurrentUserQuery } from "./graphql"

const uploadLink = new UploadHttpLink({ credentials: "include", uri: "/graphql" })

const localeLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      "X-App-Locale": normalizeLocale(i18n.locale) || DEFAULT_LOCALE,
    },
  }))

  return forward(operation)
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([localeLink, uploadLink]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
    },
  },
})

// TODO: wait until this is no longer experimental, then implement react-router loaders
// export const preloadQuery = createQueryPreloader(client);

export const ApolloClientProvider = ({
  currentUser,
  children,
}: {
  currentUser?: GetCurrentUserQuery["currentUser"]
  children: ReactNode
}) => {
  useEffect(() => {
    if (currentUser) {
      client.writeQuery({
        query: GetCurrentUserDocument,
        data: { currentUser },
      })
    }
  }, [currentUser])
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
